import FlashCancellationPolicies from 'components/Common/CancellationPolicies/Flash/FlashCancellationPolicies'
import Group from 'components/utils/Group'
import Sheet from 'components/utils/Sheet'
import LoyaltyPoints from 'loyalty/components/LoyaltyPoints'
import { generateLoyaltyPointsCalculatorBundledFlightOptions, generateLoyaltyPointsCalculatorHotelOptions } from 'loyalty/lib/pointsCalculation/calculatorOptionsGenerators'
import React, { useMemo } from 'react'
import { isAvailableForPurchase, OfferPackageOptionView } from 'selectors/offerPage/offerPageSelectors'
import styled from 'styled-components'
import MultipleRoomsInclusions from '../MultipleRoomsInclusions'
import MobileMultipleRoomsRoomOptionPriceDetails from './MobileMultipleRoomsRoomOptionPriceDetails'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { EmptyArray } from 'lib/array/arrayUtils'
import Caption from 'components/Luxkit/Typography/Caption'

const StyledSheet = styled(Sheet)`
  min-width: 75vw;
`
interface Props {
  offer: App.HotelOffer;
  checkIn?: string;
  rooms: Array<App.RoomOccupants>;
  availableForPurchase?: boolean;
  isFlightsSelected: boolean;
  packageView: OfferPackageOptionView;
  isSelected?: boolean;
  children?: React.ReactNode;
  childrenCtaDirection?: 'horizontal' | 'vertical';
  packagePosition: number;
}

function MobileMultipleRoomsCarouselPackageOption(props: Props) {
  const {
    packageView,
    offer,
    checkIn,
    availableForPurchase,
    rooms,
    isFlightsSelected,
    isSelected,
    children,
    childrenCtaDirection,
    packagePosition,
  } = props

  const room = rooms[0]

  const pointsEarnCalculationRequests: [App.LoyaltyPointsEarnCalculationRequest | undefined, App.LoyaltyPointsEarnCalculationRequest | undefined] = useMemo(() => [
    generateLoyaltyPointsCalculatorHotelOptions(offer, { packageView }),
    generateLoyaltyPointsCalculatorBundledFlightOptions(offer, { packageView, skip: !isFlightsSelected }),
  ], [isFlightsSelected, offer, packageView])

  return (
    <StyledSheet
      border={isSelected ? 'neutral-one' : 'neutral-six'}
      padding={16}
      key={packageView.package.uniqueKey}
    >
      <Group direction="vertical" gap={12}>
        <Group direction="vertical" gap={4}>
          <Caption variant="medium">Package option {packagePosition}</Caption>
          {availableForPurchase && <FlashCancellationPolicies
            checkInDate={checkIn}
            propertyTimezoneOffset={offer.property?.timezoneOffset}
            cancellationPolicy={packageView.package.roomRate?.cancellationPolicy}
          />}
        </Group>
        {availableForPurchase && <MultipleRoomsInclusions
          offer={offer}
          packageOption={packageView}
        />}
        <LoyaltyPoints
          calculationRequests={pointsEarnCalculationRequests}
          calculationType={(!checkIn || isFlightsSelected) ? 'estimate' : 'exact'}
        />
        {availableForPurchase && <MobileMultipleRoomsRoomOptionPriceDetails
          room={room}
          packageOption={packageView}
          ctaDirection={childrenCtaDirection}
        >
          {children}
        </MobileMultipleRoomsRoomOptionPriceDetails>}
      </Group>
    </StyledSheet>
  )
}

type MappedProps = Pick<Props,
  'offer'
  | 'rooms'
  | 'checkIn'
  | 'isFlightsSelected'
  | 'availableForPurchase'
>

export default withOfferPageAndReduxState((state, appState): MappedProps => ({
  offer: state.offer as App.HotelOffer,
  rooms: state.rooms ?? EmptyArray as Array<App.RoomOccupants>,
  checkIn: state.checkInDate,
  isFlightsSelected: state.flights,
  availableForPurchase: isAvailableForPurchase(state, appState),
}), MobileMultipleRoomsCarouselPackageOption)
